import type { Texture } from 'pixi.js';

export const createTextureCanvasContext = (
  texture: Texture,
): { ctx: CanvasRenderingContext2D; width: number; height: number } | null => {
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  if (!ctx) {
    return null;
  }

  const width = texture.width;
  const height = texture.height;
  canvas.width = width;
  canvas.height = height;
  return { ctx, width, height };
};

export const getDrawableTextureSource = (
  texture: Texture,
): HTMLImageElement | HTMLCanvasElement | null => {
  const resource = texture.source?.resource;
  if (
    resource instanceof HTMLImageElement ||
    resource instanceof HTMLCanvasElement
  ) {
    return resource;
  }
  return null;
};

export const readTextureImageData = (
  ctx: CanvasRenderingContext2D,
  width: number,
  height: number,
): ImageData => ctx.getImageData(0, 0, width, height);

export const calculateOpaqueCenterOfMass = (
  data: Uint8ClampedArray,
  width: number,
  height: number,
): { x: number; y: number } | null => {
  let totalX = 0;
  let totalY = 0;
  let pixelCount = 0;

  for (let y = 0; y < height; y++) {
    for (let x = 0; x < width; x++) {
      const index = (y * width + x) * 4;
      const alpha = data[index + 3];
      if (alpha > 128) {
        totalX += x;
        totalY += y;
        pixelCount++;
      }
    }
  }

  if (pixelCount === 0) {
    return null;
  }

  return {
    x: totalX / pixelCount,
    y: totalY / pixelCount,
  };
};
